import { Component, OnInit } from '@angular/core';
import { sessionStorageKey } from '../doctors-station.constants';

@Component({
  selector: 'app-doctors-station-change-password-sent',
  templateUrl: './doctors-station-change-password-sent.component.html',
  styleUrls: [
    '../style/global.css',
    './doctors-station-change-password-sent.component.css',
  ],
})
export class DoctorsStationChangePasswordSentComponent implements OnInit {
  email: string;
  constructor() {
    this.email = sessionStorage.getItem(sessionStorageKey.passwordResetEmail);
    if (!this.email) {
      history.back();
    }
  }

  ngOnInit(): void {}
}
